import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12L8 16C8 16.5523 8.44771 17 9 17C9.55228 17 10 16.5523 10 16V12Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M12 12C12.5523 12 13 12.4477 13 13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13C11 12.4477 11.4477 12 12 12Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M16 14C16 13.4477 15.5523 13 15 13C14.4477 13 14 13.4477 14 14V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V14Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 6C4 4.34315 5.34315 3 7 3H13C16.866 3 20 6.13401 20 10V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V6ZM7 5C6.44772 5 6 5.44772 6 6V18C6 18.5523 6.44772 19 7 19H17C17.5523 19 18 18.5523 18 18V11H15C13.3431 11 12 9.65685 12 8V5H7ZM14 5.10002C15.9591 5.4977 17.5023 7.04087 17.9 9H15C14.4477 9 14 8.55228 14 8V5.10002Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}